import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import design from "../../asset/Image/design.png";
import ecommerce from "../../asset/Image/ecommerce.png";
import web from "../../asset/Image/web.png";
import AppUrl from "../../RestApi/AppUrl";
import RestClient from "../../RestApi/RestClient";
import Loader from "../../shared/Loader/Loader";
import WentWrong from "../../shared/WentWrong/WentWrong";
import serviceCss from "./Service.module.css";
import Roll from "react-reveal/Roll";
import Fade from "react-reveal/Fade";
export default function Service() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    RestClient.GetRequest(AppUrl.AllService).then((result) => {
      if (result == null) {
        setError(true);
      } else {
        setServices(result);
        setLoading(false);
      }
    });
  }, []);
  return (
    <>
      {loading && <Loader />}
      <Container className="my-5 text-center">
        <Fade top>
          <h1 className={`${serviceCss.serviceMainTitle}`}>My Service</h1>
        </Fade>
        <div className={`${serviceCss.bottom}`}></div>
        {!error ? (
          <Roll right>
            <Row>
              {services.map((service, i) => {
                return (
                  <Col md={6} lg={4} sm={12} key={i}>
                    <Card className={`${serviceCss.cardContainer}`}>
                      <Card.Body>
                        <Card.Img src={service.service_logo} className="w-25" />
                        <Card.Title className={`${serviceCss.cardTitle}`}>
                          {service.service_name}
                        </Card.Title>
                        <Card.Text className="description">
                          {service.service_description}
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </Roll>
        ) : (
          <WentWrong />
        )}
      </Container>
    </>
  );
}
